/*
 * Copyright (c) 2024 NOOGA DEVELOPMENT, All rights reserved.
 * Author Julia Romanovskaya <julia.romanovskaya@noogadev.com>
 */

import { CashBoxLastDocument } from '../../../api/cashBoxes/cashBoxesClient.typings';
import {
    CashBoxLastDocumentTabAction,
    CashBoxLastDocumentTabActionType,
} from '../../../actions/CashBoxRegistry/Tabs/cashBoxLastDocumentActions';

export interface CashBoxLastDocumentTabState {
    lastDocument: CashBoxLastDocument;
    isLoadingLastDocument: boolean;
}
const initialState: CashBoxLastDocumentTabState = {
    lastDocument: null,
    isLoadingLastDocument: false,
};

export function cashBoxLastDocumentTabReducer(
    state: CashBoxLastDocumentTabState = initialState,
    action: CashBoxLastDocumentTabAction,
): CashBoxLastDocumentTabState {
    switch (action.type) {
        case CashBoxLastDocumentTabActionType.FETCH_LAST_DOCUMENT:
            return {
                ...state,
                isLoadingLastDocument: true,
            };

        case CashBoxLastDocumentTabActionType.FETCH_LAST_DOCUMENT_SUCCESS:
            return {
                ...state,
                lastDocument: Object.keys(action.payload).length === 0 ? null : action.payload,
                isLoadingLastDocument: false,
            };

        case CashBoxLastDocumentTabActionType.FETCH_LAST_DOCUMENT_ERROR:
            return {
                ...state,
                isLoadingLastDocument: false,
                lastDocument: null,
            };

        case CashBoxLastDocumentTabActionType.EXIT_LAST_DOCUMENT_TAB:
            return {
                ...state,
                lastDocument: null,
            };

        default:
            break;
    }
    return state;
}
